<template>
  <div class="number__previousSelected">
    <label :for="number"
      >Previously selected number:<br /><input
        :id="number"
        name="prevselect"
        type="radio"
        :checked="checked"
        @click="previousClicked($event)"
      />{{ formatted }}</label
    >
  </div>
</template>

<script>
import { eventBus } from "../main";
export default {
  props: {
    checked: {
      type: Boolean
    },
    number: {
      type: String
    },
    formatted: {
      type: String
    }
  },
  methods: {
    previousClicked(event) {
      let number = event.target.id;
      eventBus.$emit("previous-selected", number);
    }
  }
};
</script>

<style></style>
